// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ErrorModal$PorterinFeature from "../../ui/components/ErrorModal.mjs";
import * as AttachVehicleModal$PorterinFeature from "../../containers/partners/view/components/AttachVehicleModal.mjs";
import * as BookingDetailsModal$PorterinFeature from "../../containers/fare-estimate-v1/view/components/order-address-card/view/BookingDetailsModal.mjs";
import * as BookingFlowBindings$PorterinFeature from "../../containers/bindings/BookingFlowBindings.mjs";
import * as CitySelectorModalCmp$PorterinFeature from "../../shared/city-selector/view/components/CitySelectorModalCmp.mjs";
import * as FareEstimateModalCmp$PorterinFeature from "../../shared/modal/view/components/FareEstimateModalCmp.mjs";
import * as SpotRequirementModal$PorterinFeature from "../../shared/spot-lead-flow/view/components/SpotRequirementModal.mjs";
import * as PaymentStatusModalCmp$PorterinFeature from "../../containers/pnm/view/components/PaymentStatusModalCmp.mjs";
import * as PnmBookingFlowModalCmp$PorterinFeature from "../../containers/pnm/view/components/PnmBookingFlowModalCmp.mjs";
import * as PnMFareEstimateModalCmp$PorterinFeature from "../../containers/pnm/view/components/PnMFareEstimateModalCmp.mjs";
import * as BookingFlowBindingsHelper$PorterinFeature from "../../containers/bindings/helpers/BookingFlowBindingsHelper.mjs";
import * as VehicleCitySelectorModalCmp$PorterinFeature from "../../shared/vehicles/view/components/VehicleCitySelectorModalCmp.mjs";
import * as VehicleFareEstimateModalCmp$PorterinFeature from "../../shared/modal/view/components/VehicleFareEstimateModalCmp.mjs";
import * as PnMCallbackConfirmationModalCmp$PorterinFeature from "../../containers/pnm/view/components/PnMCallbackConfirmationModalCmp.mjs";

function getModalComponent(modalState, toggleModal) {
  if (modalState === undefined) {
    return null;
  }
  switch (modalState.TAG | 0) {
    case /* ErrorModal */0 :
        var error_source = modalState._2;
        return React.createElement(ErrorModal$PorterinFeature.make, {
                    modal_state: modalState._0,
                    close_modal: (function (param) {
                        Curry._1(toggleModal, (function (param) {
                                
                              }));
                      }),
                    error: modalState._1,
                    error_source: error_source,
                    toggle_booking_pickup: (function (param) {
                        if (error_source !== 0) {
                          if (error_source >= 3) {
                            return Curry._1(toggleModal, (function (param) {
                                          return {
                                                  TAG: /* EditOrderReviewAddress */4,
                                                  _0: true,
                                                  _1: /* Pickup */0
                                                };
                                        }));
                          } else {
                            return ;
                          }
                        } else {
                          return Curry._1(toggleModal, (function (param) {
                                        return {
                                                TAG: /* BookingDetails */5,
                                                _0: true,
                                                _1: /* Pickup */0,
                                                _2: true
                                              };
                                      }));
                        }
                      }),
                    toggle_booking_dropoff: (function (param) {
                        if (error_source !== 0) {
                          if (error_source >= 3) {
                            return Curry._1(toggleModal, (function (param) {
                                          return {
                                                  TAG: /* EditOrderReviewAddress */4,
                                                  _0: true,
                                                  _1: /* Dropoff */1
                                                };
                                        }));
                          } else {
                            return ;
                          }
                        } else {
                          return Curry._1(toggleModal, (function (param) {
                                        return {
                                                TAG: /* BookingDetails */5,
                                                _0: true,
                                                _1: /* Dropoff */1,
                                                _2: true
                                              };
                                      }));
                        }
                      })
                  });
    case /* VehicleFareEstimate */1 :
        return React.createElement(VehicleFareEstimateModalCmp$PorterinFeature.make, {
                    modal: {
                      modal_state: modalState._0,
                      close_modal: (function (param) {
                          Curry._1(toggleModal, (function (param) {
                                  
                                }));
                        })
                    },
                    service_category: modalState._1,
                    vehicle: modalState._2,
                    fare_estimate_form_content: modalState._3
                  });
    case /* VehicleCitySelector */2 :
        return React.createElement(VehicleCitySelectorModalCmp$PorterinFeature.make, {
                    modal: {
                      modal_state: modalState._0,
                      close_modal: (function (param) {
                          Curry._1(toggleModal, (function (param) {
                                  
                                }));
                        })
                    },
                    city_selector_data: modalState._1,
                    service_category: modalState._2,
                    current_city: modalState._3,
                    city_title_desc: modalState._4,
                    close_icon: modalState._5
                  });
    case /* BookingDetails */5 :
        var is_address_modal_open = modalState._2;
        var waypoint = modalState._1;
        var modalState$1 = modalState._0;
        return React.createElement(BookingDetailsModal$PorterinFeature.make, {
                    modal_state: modalState$1,
                    close_modal: (function (param) {
                        Curry._1(toggleModal, (function (param) {
                                return {
                                        TAG: /* BookingDetails */5,
                                        _0: !modalState$1,
                                        _1: waypoint,
                                        _2: is_address_modal_open
                                      };
                              }));
                      }),
                    waypoint: waypoint,
                    is_address_modal_open: is_address_modal_open
                  });
    case /* SpotRequirement */6 :
        return React.createElement(SpotRequirementModal$PorterinFeature.make, {
                    modal_state: modalState._0,
                    close_modal: (function (param) {
                        Curry._1(toggleModal, (function (param) {
                                
                              }));
                      }),
                    requirement: modalState._2,
                    form: modalState._1,
                    requirement_content: modalState._3
                  });
    case /* CitySelector */7 :
        return React.createElement(CitySelectorModalCmp$PorterinFeature.make, {
                    modalState: modalState._0,
                    close_modal: (function (param) {
                        Curry._1(toggleModal, (function (param) {
                                
                              }));
                      }),
                    city_selector_data: modalState._1,
                    close_icon: modalState._2,
                    city_title_desc: modalState._3
                  });
    case /* FareEstimateModal */9 :
        return React.createElement(FareEstimateModalCmp$PorterinFeature.make, {
                    modalState: modalState._0,
                    close_modal: (function (param) {
                        Curry._1(toggleModal, (function (param) {
                                
                              }));
                      }),
                    category_cards_data: modalState._1,
                    fare_estimate_form_content: modalState._2,
                    modal_content: modalState._3
                  });
    case /* AttachVehicleModal */10 :
        var modalState$2 = modalState._0;
        return React.createElement(AttachVehicleModal$PorterinFeature.make, {
                    modalState: modalState$2,
                    close_modal: (function (param) {
                        Curry._1(toggleModal, (function (param) {
                                return {
                                        TAG: /* AttachVehicleModal */10,
                                        _0: !modalState$2
                                      };
                              }));
                      })
                  });
    case /* Auth */11 :
        var onOtpValid = modalState._4;
        var authContext = modalState._3;
        var prefillData = modalState._2;
        var authState = modalState._1;
        var modalState$3 = modalState._0;
        var tmp;
        if (typeof authState === "number") {
          switch (authState) {
            case /* LoginScreenV2 */4 :
                tmp = "login";
                break;
            case /* SignupScreen */0 :
            case /* SignupReqSelection */1 :
            case /* Profile */3 :
            case /* SignupScreenV2 */5 :
                tmp = "signup";
                break;
            case /* OtpValidation */2 :
            case /* OtpValidationV2 */6 :
                tmp = "otp";
                break;
            
          }
        } else {
          tmp = "login";
        }
        return React.createElement(BookingFlowBindings$PorterinFeature.AuthModal.make, {
                    isOpen: modalState$3,
                    variant: tmp,
                    onClose: (function (param) {
                        Curry._1(toggleModal, (function (param) {
                                return {
                                        TAG: /* Auth */11,
                                        _0: !modalState$3,
                                        _1: authState,
                                        _2: prefillData,
                                        _3: authContext,
                                        _4: onOtpValid
                                      };
                              }));
                      }),
                    prefillData: prefillData !== undefined ? ({
                          mobile: prefillData.mobile,
                          name: prefillData.name,
                          requirement: prefillData.requirement_type
                        }) : ({
                          mobile: undefined,
                          name: undefined,
                          requirement: undefined
                        }),
                    authContext: BookingFlowBindingsHelper$PorterinFeature.authContextConverter(authContext),
                    onOtpValid: onOtpValid
                  });
    case /* PnMBookingFlow */14 :
        var mobile = modalState._2;
        var sr_external_id = modalState._1;
        var modalState$4 = modalState._0;
        return React.createElement(PnmBookingFlowModalCmp$PorterinFeature.make, {
                    modal_state: modalState$4,
                    close_modal: (function (param) {
                        Curry._1(toggleModal, (function (param) {
                                return {
                                        TAG: /* PnMBookingFlow */14,
                                        _0: !modalState$4,
                                        _1: sr_external_id,
                                        _2: mobile
                                      };
                              }));
                      }),
                    sr_external_id: sr_external_id,
                    mobile: mobile
                  });
    case /* PnMCallbackConfirmationModal */15 :
        var modalState$5 = modalState._0;
        return React.createElement(PnMCallbackConfirmationModalCmp$PorterinFeature.make, {
                    modal_state: modalState$5,
                    close_modal: (function (param) {
                        Curry._1(toggleModal, (function (param) {
                                return {
                                        TAG: /* PnMCallbackConfirmationModal */15,
                                        _0: !modalState$5
                                      };
                              }));
                      })
                  });
    case /* PnMFareEstimateModal */16 :
        var show_house_field = modalState._1;
        var modalState$6 = modalState._0;
        return React.createElement(PnMFareEstimateModalCmp$PorterinFeature.make, {
                    modal_state: modalState$6,
                    close_modal: (function (param) {
                        Curry._1(toggleModal, (function (param) {
                                return {
                                        TAG: /* PnMFareEstimateModal */16,
                                        _0: !modalState$6,
                                        _1: show_house_field
                                      };
                              }));
                      }),
                    show_house_field: show_house_field
                  });
    case /* PaymentStatusModal */17 :
        var booking_flow = modalState._2;
        var payment_status = modalState._1;
        var modalState$7 = modalState._0;
        return React.createElement(PaymentStatusModalCmp$PorterinFeature.make, {
                    modal_state: modalState$7,
                    close_modal: (function (param) {
                        Curry._1(toggleModal, (function (param) {
                                return {
                                        TAG: /* PaymentStatusModal */17,
                                        _0: !modalState$7,
                                        _1: payment_status,
                                        _2: booking_flow
                                      };
                              }));
                      }),
                    payment_status: payment_status,
                    booking_flow: booking_flow
                  });
    default:
      return null;
  }
}

function useModal(initialState) {
  var match = React.useState(function () {
        return initialState;
      });
  var toggleModal = match[1];
  var modalState = match[0];
  var modalComponent = getModalComponent(modalState, toggleModal);
  return [
          modalComponent,
          modalState,
          toggleModal
        ];
}

export {
  getModalComponent ,
  useModal ,
}
/* react Not a pure module */
